import loadable from '@loadable/component';

export const BCHeaderBlockEdit = loadable(
  () => import(/* webpackChunkName: "redturtle__volto-blocks" */ './Edit'),
);
